export default __webpack_public_path__ + "static/media/cardsIcon.6d98cc3c.svg";